const defaultForm = {
  message: '',
  fb_preset_id: 0,
  pages: [],
  reply_message: '',
  schedule_type: 'now',
  schedule_time: '',
  template_id: '',
  type: 'message',
  files: [],
}
export default {
  namespaced: true,
  state: {
    form: defaultForm,
    images: [{ url: '' }],
  },
  getters: {
    form: (state: any) => state.form,
    images: (state: any) => state.images ?? [],
  },
  mutations: {
    SET_FORM(state: any, form: any) {
      state.form = { ...state.form, ...form }
    },
  },
  actions: {
  },
}
